/**
 *
 * @param node
 * @returns {StoryboardStepEntry}
 */
StoryboardStepEntry.create = function (storyboardStep) {
    var storyboardStepEntry = new StoryboardStepEntry();

    storyboardStepEntry.__storyboardStep = storyboardStep;
    storyboardStepEntry.action = {type: "nodeService", content: {}};
    storyboardStepEntry.easing = "linear";

    return storyboardStepEntry;
};

/**
 *
 * @param node
 * @param storyboardStep
 * @returns {*}
 */
StoryboardStepEntry.bind = function (storyboardStep, storyboardStepEntry) {
    Utils.inheritMethods(storyboardStepEntry, new StoryboardStepEntry());

    storyboardStepEntry.bind(storyboardStep);

    return storyboardStepEntry;
};

/**
 *
 */
function StoryboardStepEntry() {
    /**
     *
     */
    StoryboardStepEntry.prototype.bind = function (storyboardStep) {
        this.__storyboardStep = storyboardStep;
    };

    /**
     *
     */
    StoryboardStepEntry.prototype.details = function () {
        var label = "";

        if (this.action.type === "nodeService") {
            label += this.__storyboardStep.__storyboard.__node.getService(this.action.content.service).label;
        }
        else if (this.action.type === "deviceService") {
            label += this.__storyboardStep.__storyboard.__node.getDevice(this.action.content.device).label;
            label += ".";
            label += this.__storyboardStep.__storyboard.__node.getDevice(this.action.content.device).getService(this.action.content.service);
        }
        else if (this.action.type === "actorService") {
            label += this.__storyboardStep.__storyboard.__node.getDevice(this.action.content.device).label;
            label += ".";
            label += this.action.content.actor;
            label += ".";
            label += this.action.content.service;
        }

        if (this.easing) {
            label += " (" + this.easing + " Easing)";
        }

        return label;
    }
}
